//----------------------------------------------------
// Win10AdminLayout.jsx — Windows 10 stijl layout
// Logboek24 Admin Console Layout met klikbare sidebar
//----------------------------------------------------
import React from "react";
import {
  FiHome,
  FiUsers,
  FiSettings,
  FiDatabase,
  FiLink,
  FiFileText,
  FiActivity,
  FiAlertTriangle,
  FiShield,
  FiLifeBuoy,
} from "react-icons/fi";
import { NavLink } from "react-router-dom";
import { useUser } from "../context/UserContext";

export default function Win10AdminLayout({ children }) {
  const { logout } = useUser();

  function handleLogout() {
    logout?.();
    window.location.href = "/";
  }

  return (
    <div className="flex h-screen bg-gray-100">

      {/* Sidebar */}
      <aside className="w-60 bg-white border-r border-gray-300 shadow-sm flex flex-col">
        
        {/* Sidebar header */}
        <div className="px-4 py-4 border-b border-gray-300">
          <h1 className="text-xl font-semibold text-gray-800">
            Logboek24 Admin
          </h1>
        </div>

        {/* Navigatie */}
        <nav className="flex-1 overflow-y-auto">
          <ul className="mt-2">
            <MenuItem to="/admin/dashboard" icon={<FiHome />} label="Dashboard" />
            <MenuItem to="/admin/tenants" icon={<FiUsers />} label="Tenants" />
            <MenuItem to="/admin/users" icon={<FiDatabase />} label="Gebruikers" />
            <MenuItem to="/admin/integrations" icon={<FiLink />} label="Koppelingen" />
            <MenuItem to="/admin/operations" icon={<FiActivity />} label="Platform monitoring" />
            <MenuItem to="/admin/security" icon={<FiShield />} label="Security & incidenten" />
            <MenuItem to="/admin/support-tickets" icon={<FiLifeBuoy />} label="Support tickets" />
            <MenuItem to="/admin/settings" icon={<FiSettings />} label="Instellingen" />
          </ul>
        </nav>

        {/* Footer */}
        <div className="px-4 py-3 border-t border-gray-300 text-sm text-gray-600">
          © {new Date().getFullYear()} Logboek24
        </div>

      </aside>

      {/* Rechterkant */}
      <div className="flex-1 flex flex-col">

        {/* Topbar */}
        <header className="bg-white h-12 border-b border-gray-300 shadow-sm flex items-center justify-between px-4">
          <div className="text-sm text-gray-600">
            Windows 10 Admin Paneel
          </div>

          <div className="flex items-center gap-3">
            <div className="text-sm text-gray-800 font-medium">
              Admin • beheerder
            </div>
            <button
              type="button"
              onClick={handleLogout}
              className="rounded border border-gray-300 bg-white px-3 py-1 text-sm text-gray-700 hover:bg-gray-50"
            >
              Uitloggen
            </button>
          </div>
        </header>

        {/* Main content */}
        <main className="flex-1 overflow-y-auto p-6">
          {children}
        </main>

      </div>
    </div>
  );
}

// ----------------------------------------------------
// Subcomponent: Sidebar item (klikbaar + active state)
// ----------------------------------------------------
function MenuItem({ icon, label, to }) {
  return (
    <li>
      <NavLink
        to={to}
        className={({ isActive }) =>
          [
            "flex items-center px-4 py-2 cursor-pointer select-none border-l-4 transition",
            isActive
              ? "bg-blue-100 border-blue-500"
              : "border-transparent hover:bg-blue-50"
          ].join(" ")
        }
      >
        <span className="text-gray-600 text-lg mr-3">{icon}</span>
        <span className="text-gray-800">{label}</span>
      </NavLink>
    </li>
  );
}
